export default {
  Title: "权限管理",
  rName: "名称",
  cName: "公司",
};
